<div class="modal fade" id="filtersModal" tabindex="-1" role="dialog" aria-labelledby="filtersModal" aria-hidden="true">
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button
					type="button"
					class="btn-close"
					(click)="filtersClose()"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="modal-body">
				<p class="w-100 d-flex justify-content-end mb-3">
					<mat-slide-toggle [(ngModel)]="showAdvanced" labelPosition="before" color="primary"
						>Zaawansowane</mat-slide-toggle
					>
				</p>
				<div class="mb-3">
					<div class="row g-2">
						<div class="form-floating col-md">
							<input
								type="date"
								class="form-control"
								name="accommodation_after"
								id="accommodation_after"
								[(ngModel)]="filters.accommodation_after"
							/>
							<label for="accommodation_after" class="form-label">Zakwaterowanie od</label>
						</div>
						<div class="form-floating col-md">
							<input
								type="date"
								class="form-control"
								name="accommodation_before"
								id="accommodation_before"
								[(ngModel)]="filters.accommodation_before"
							/>
							<label for="accommodation_before" class="form-label">Wykwaterowanie do</label>
						</div>
					</div>
				</div>
				@if (showAdvanced()) {
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="departure_time_after"
									id="departure_time_after"
									[(ngModel)]="filters.departure_time_after"
								/>
								<label for="departure_time_after" class="form-label">Wyjazd od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="departure_time_before"
									id="departure_time_before"
									[(ngModel)]="filters.departure_time_before"
								/>
								<label for="departure_time_before" class="form-label">Wyjazd do</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="return_time_after"
									id="return_time_after"
									[(ngModel)]="filters.return_time_after"
								/>
								<label for="return_time_after" class="form-label">Powrót od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="return_time_before"
									id="return_time_before"
									[(ngModel)]="filters.return_time_before"
								/>
								<label for="return_time_before" class="form-label">Powrót do</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="earliest_deadline_after"
									id="earliest_deadline_after"
									[(ngModel)]="filters.earliest_deadline_after"
								/>
								<label for="earliest_deadline_after" class="form-label">Termin wykonania od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="earliest_deadline_before"
									id="earliest_deadline_before"
									[(ngModel)]="filters.earliest_deadline_before"
								/>
								<label for="earliest_deadline_before" class="form-label">Termin wykonania do</label>
							</div>
						</div>
					</div>
				}

				<div class="mb-3">
					<ng-select
						id="name"
						name="name"
						[(ngModel)]="filters.name"
						[multiple]="true"
						[closeOnSelect]="false"
						placeholder="Oferta"
					>
						<ng-option *ngFor="let item of names" [value]="item.name">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<ng-select
						id="status"
						name="status"
						[(ngModel)]="filters.status"
						[multiple]="true"
						[closeOnSelect]="false"
						placeholder="Statusy"
					>
						<ng-option *ngFor="let item of statuses" [value]="item.value">{{ item.viewValue }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<ng-select
						id="kind"
						name="kind"
						[(ngModel)]="filters.kind"
						[multiple]="true"
						[closeOnSelect]="false"
						placeholder="Typ transportu"
					>
						@for (kind of offerTransportKinds; track $index) {
							<ng-option [value]="kind.key">{{ kind.label }}</ng-option>
						}
					</ng-select>
				</div>
				<div class="mb-3">
					<ng-select
						id="yesno"
						name="yesno"
						[(ngModel)]="filters.swinging"
						[multiple]="false"
						[closeOnSelect]="false"
						placeholder="Wahadło"
					>
						<ng-option *ngFor="let item of yesno" [value]="item.value">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<div class="row g-2">
						<div class="form-floating col-md">
							<ng-select
								id="transport_departure_exists"
								name="transport_departure_exists"
								[(ngModel)]="filters.transport_departure_exists"
								[multiple]="false"
								[closeOnSelect]="false"
								placeholder="Transport do"
							>
								<ng-option *ngFor="let item of yesno" [value]="item.value">{{ item.name }}</ng-option>
							</ng-select>
						</div>
						<div class="form-floating col-md">
							<ng-select
								id="transport_return_exists"
								name="transport_return_exists"
								[(ngModel)]="filters.transport_return_exists"
								[multiple]="false"
								[closeOnSelect]="false"
								placeholder="Transport z"
							>
								<ng-option *ngFor="let item of yesno" [value]="item.value">{{ item.name }}</ng-option>
							</ng-select>
						</div>
					</div>
				</div>
				<div class="mb-3">
					<ng-select
						id="responsibleUser"
						name="responsibleUser"
						[(ngModel)]="filters.responsible_user"
						[multiple]="true"
						[closeOnSelect]="false"
						[appendTo]="'body'"
						placeholder="Osoba odpowiedzialna"
					>
						@for (user of allUsers(); track user.id) {
							<ng-option [value]="user.id">{{ user.firstName }} {{ user.lastName }}</ng-option>
						}
					</ng-select>
				</div>
			</div>
			<div class="modal-footer">
				<div class="btn-group me-auto">
					<button type="button" class="btn btn-danger" (click)="filtersClear()">Wyczyść</button>
				</div>
				<div class="btn-group">
					<button type="button" class="btn btn-primary" (click)="filtersSave()">Pokaż</button>
					<button type="button" class="btn btn-secondary" (click)="filtersClose()">Anuluj</button>
				</div>
			</div>
		</div>
	</div>
</div>
